import { render } from "./Portal.vue?vue&type=template&id=471deed0&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"

import "./Portal.vue?vue&type=style&index=0&id=471deed0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-471deed0"

export default script